// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64bfc412","963":"1968961d"}[chunkId] + ".chunk.js";
};